'use strict';
const _ = require('underscore');
const Backbone = require('backbone');
const SyncStateModel = require('system/domain/entity/sync-state');
const EditModeMixin = require('system/domain/entity/edit-mode-mixin');

var NodeMetaModel = Backbone.Model.extend({
    previousPosition: {x: null, y: null},
    defaults: {
        creating: false,
        deleting: false,
        x: 0,
        y: 0,
        is_zone: false,
        shape: null
    },

    initialize: function () {
        this.syncState = new SyncStateModel({
            state: SyncStateModel.States.synced});
        this.listenTo(this.syncState, 'change', function(state) {
            this.trigger('change:state', state);
        });
        this.previousPosition.x = this.get('x');
        this.previousPosition.y = this.get('y');
        this.x = this.get('x');
        this.y = this.get('y');
        this.on('change:x', function() {
            var pre = this.x;
            this.x = this.get('x');
            this.trigger('move', this, {dx: this.x - pre, dy: 0}, this);
        });
        this.on('change:y', function() {
            var pre = this.y;
            this.y = this.get('y');
            this.trigger('move', this, {dx: 0, dy: this.y - pre}, this);
        });

        this._nestedNodes = new Backbone.Collection();
    },

    toJSON: function () {
        var j = NodeMetaModel.__super__.toJSON.call(this);
        delete j.id;
        return j;
    },

    _snapGrid: function(pos) {
        var snapSize = 128;
        return {
            x: snapSize * Math.round(pos.x / snapSize),
            y: snapSize * Math.round(pos.y / snapSize)
        };
    },

    move: function(dpos) {
        this.x += dpos.dx;
        this.y += dpos.dy;

        var pos = {
            x: this.x,
            y: this.y
        };
        this.trigger('move', pos, dpos, this);
    },

    moveTo: function(pos) {
        this.x = pos.x;
        this.y = pos.y;
        this.trigger('move', pos, this);
    },

    moveend: function() {
        this.previousPosition = {
            x: this.get('x'),
            y: this.get('y')
        };

        var pos = this._snapGrid({
            x: this.x,
            y: this.y
        });

        // 動いていないなら set しない
        if(this.previousPosition.x == pos.x &&
            this.previousPosition.y == pos.y) {
            this.x = this.previousPosition.x;
            this.y = this.previousPosition.y;
            this.trigger('move', this.previousPosition, {dx: 0, dy: 0}, this);
            return;
        }

        this.x = pos.x;
        this.y = pos.y;
        this.trigger('move', pos, {dx: 0, dy: 0}, this);
        this.trigger('moveEnd', pos, this);
    },

    moveDistance: function() {
        if (this.previousPosition.x != null &&
            this.previousPosition.y != null) {
            var diff_x = this.get('x') - this.previousPosition.x;
            var diff_y = this.get('y') - this.previousPosition.y;
            return Math.sqrt(diff_x * diff_x + diff_y * diff_y);
        } else {
            return 0;
        }
    },

    insideZone: function(pos) {
        if(!this.get('is_zone')) {
            return false;
        }

        var shape = this.get('shape');
        var p = {
            x: this.get('x'),
            y: this.get('y')
        };
        var width = shape.attr.width;
        var height = shape.attr.height;
        return p.x - width / 2 < pos.x && pos.x < p.x + width / 2 &&
            p.y - height / 2 < pos.y && pos.y < p.y + height / 2;
    },

    getNestedNodes: function() {
        return this._nestedNodes;
    },

    addNestedNode: function(node) {
        this._nestedNodes.add(node, {silent: true});
    },

    removeNestedNode: function(node) {
        this._nestedNodes.remove(node, {silent: true});
    }
});

_.extend(NodeMetaModel.prototype, EditModeMixin);

module.exports = NodeMetaModel;



// WEBPACK FOOTER //
// ./system/domain/entity/node-meta.js